export default "__VITE_ASSET__DTPHdFol__"